import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HeaderService } from '../../header.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as Globals from '../../globals';
import { Pejabat } from './../../pejabat';
import { PEJABAT } from './../../mock-pejabat';
import { PejabatService } from 'app/pejabat.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  userProfile: any;
  reportList: any[];
  officer: any;
  param: any;
  reportTitle: string = '';
  @Input() seriesId: number;
  @Input() btid: number;
  @Input() cdAucType: string;
  fileUrl: string = '';
  rptName: string = '';
  rptCwls: string = '';
  loading: boolean;
  parts: any[];
  subreg: any[];
  pejabats: any[];
  // [{ id: 1, name: 'Luky Alfirman' }, { id: 2, name: 'Safuadi' }, { id: 3, name: 'Scenaider Clasein H. Siahaan' }, { id: 4, name: 'Loto Srinaita Ginting' }, { id: 5, name: 'Dwi Irianti Hadiningdyah' }, { id: 6, name: 'Brahmantio Isdijoso' }, { id: 7, name: 'Freddy R. Saragih' }, { id: 8, name: 'Riko Amir' }, { id: 9, name: 'Heri Setiawan' }];
  pejabat: any;
  selectedPejabat: '';
  arrayOfPejabat: string[] = ['Suminto', 'Ubaidi Socheh Hamidi', 'Syurkani Ishak Kasim', 'Deni Ridwan', 'Dwi Irianti Hadiningdyah', 'Riko Amir', 'Heri Setiawan', 'Brahmantio Isdijoso','Endah Martiningrum'];
  constructor(private http: Http, private headerService: HeaderService, public toastr: ToastsManager, vRef: ViewContainerRef, private pejabatService: PejabatService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.officer = { NAME: 'Suminto', NIP: '197207071996031002', TITLE: 'Direktur Jenderal Pengelolaan Pembiayaan dan Risiko', DOC_DATE: new Date() };
  }

  ngOnInit() {
    if (this.cdAucType == '1') {
      this.reportList = [
        { id: 1, deskripsi: 'Penjatahan Issuance - Summary', name: 'rpt1101' },
        { id: 2, deskripsi: 'Penjatahan Issuance per Agen Penjual', name: 'rpt1102' },
        { id: 3, deskripsi: 'Penjatahan Issuance per Agen Penjual - per Subreg', name: 'rpt1103' },
        { id: 4, deskripsi: 'Penjatahan Issuance per Subreg - per Agen Penjual', name: 'rpt1104' },
        { id: 5, deskripsi: 'Penjatahan Issuance per Agen Penjual - per Investor', name: 'rpt1105' },
        { id: 6, deskripsi: 'Penjatahan Issuance per Subreg - per Investor', name: 'rpt1106' },
        { id: 7, deskripsi: 'Penawaran Issuance - Summary Penawaran', name: 'rpt1201' },
        { id: 8, deskripsi: 'Penawaran Issuance per Agen Penjual', name: 'rpt1202' },
        { id: 9, deskripsi: 'Penawaran Issuancen per Agen Penjual - per Investor', name: 'rpt1203' },
        { id: 10, deskripsi: 'Statistik Penawaran Issuance', name: 'rpt1301' },
        { id: 11, deskripsi: 'Distribusi Issuance', name: 'rpt1302' },
        { id: 12, deskripsi: 'Penjualan Issuance', name: 'rpt1401' },
        { id: 13, deskripsi: 'Sebaran Jangkauan Pemesanan - Per Agen Penjual Per Provinsi', name: 'rpt1303' },
        { id: 14, deskripsi: 'Rata-rata Volume Penjualan - Per Agen Penjual', name: 'rpt1304' },
        { id: 15, deskripsi: 'Volume Penjualan dan Investor - Per Provinsi', name: 'rpt1305' }
      ];
    }
    else {
      this.reportList = [
        { id: 1, deskripsi: 'Penjatahan Early Redemption - Summary', name: 'rpt101' },
        { id: 2, deskripsi: 'Penjatahan Early Redemption per Agen Penjual', name: 'rpt102' },
        { id: 3, deskripsi: 'Penjatahan Early Redemption per Agen Penjual - per Subreg', name: 'rpt103' },
        { id: 4, deskripsi: 'Penjatahan Early Redemption per Subreg - per Agen Penjual', name: 'rpt104' },
        { id: 5, deskripsi: 'Penjatahan Early Redemption per Agen Penjual - per Investor', name: 'rpt105' },
        { id: 6, deskripsi: 'Penawaran Early Redemption - Summary', name: 'rpt201' },
        { id: 7, deskripsi: 'Penawaran Early Redemption per Agen Penjual', name: 'rpt202' },
        { id: 8, deskripsi: 'Penawaran Early Redemption per Agen Penjual - per Investor', name: 'rpt203' },
        { id: 9, deskripsi: 'Statistik Penawaran Early Redemption', name: 'rpt301' },
        { id: 10, deskripsi: 'Distribusi Early Redemption', name: 'rpt302' }
      ];
    }
    this.pejabats = [{ id: 1, name: 'Suminto' },
    { id: 2, name: 'Ubaidi Socheh Hamidi' },
    { id: 3, name: 'Syurkani Ishak Kasim' },
    { id: 4, name: 'Dwi Irianti Hadiningdyah' },
    { id: 5, name: 'Brahmantio Isdijoso' },
    { id: 6, name: 'Deni Ridwan' },
    { id: 7, name: 'Riko Amir' },
    { id: 8, name: 'Heri Setiawan' },
    { id: 9, name: 'Endah Martiningrum' }];
    console.log(this.pejabats);
    this.getParts();
  }
  generateReport(format: string) {
    this.loading = true;
    // this.officer.DOC_DATE = new Date();
    if (this.rptName == 'rpt105' || this.rptName == 'rpt203' || this.rptName == 'rpt1105' || this.rptName == 'rpt1203' || this.rptName == 'rpt1106' || this.rptName == 'rpt1303') {
      this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",name:"' + this.officer.NAME + '",nip:"' + this.officer.NIP + '",title:"' + this.officer.TITLE + '",tgl:"' + Globals.formatDate(this.officer.DOC_DATE) + '",paid:' + this.officer.AP + '}' };
    } else {
      this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",name:"' + this.officer.NAME + '",nip:"' + this.officer.NIP + '",title:"' + this.officer.TITLE + '",tgl:"' + Globals.formatDate(this.officer.DOC_DATE) + '"}' };
    }

    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + this.rptName + '?id=' + this.param.TICKET_ID, '_blank');
        this.rptName = '';
        this.loading = false;
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }
  docdateChange(ev){
    this.officer.DOC_DATE = ev;
  }
  report(format: string, tipe: string) {
    console.log(this.btid);
    if (this.btid >= 5) {
      if (this.rptName == 'rpt1102') {
        this.rptCwls = 'rpt1102' + tipe;
        this.generateReportCWLS(format);
      }
      else if (this.rptName == 'rpt1103') {
        this.rptCwls = 'rpt1103' + tipe;
        this.generateReportCWLS(format);
      }
      else if (this.rptName == 'rpt1104') {
        this.rptCwls = 'rpt1104' + tipe;
        this.generateReportCWLS(format);
      }
      else if (this.rptName == 'rpt1105') {
        this.rptCwls = 'rpt1105' + tipe;
        this.generateReportCWLS(format);
      }
      else {
        this.generateReport(format);
      }
    }
    else {
      this.generateReport(format);
    }
    tipe = '';
  }
  generateReportCWLS(format: string) {
    this.loading = true;
    // this.officer.DOC_DATE = new Date();
    if (this.rptName == 'rpt105' || this.rptName == 'rpt203' || this.rptName == 'rpt1105' || this.rptName == 'rpt1105' || this.rptName == 'rpt1203' || this.rptName == 'rpt1106' || this.rptName == 'rpt1303') {
      this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",name:"' + this.officer.NAME + '",nip:"' + this.officer.NIP + '",title:"' + this.officer.TITLE + '",tgl:"' + Globals.formatDate(this.officer.DOC_DATE) + '",paid:' + this.officer.AP + '}' };
    } else {
      this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",name:"' + this.officer.NAME + '",nip:"' + this.officer.NIP + '",title:"' + this.officer.TITLE + '",tgl:"' + Globals.formatDate(this.officer.DOC_DATE) + '"}' };
    }
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + this.rptCwls + '?id=' + this.param.TICKET_ID, '_blank');
        this.loading = false;
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }
  getParts() {
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.parts = res.json();
        this.getSubreg();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
      });
  }
  getSubreg() {
    this.http.get(Globals.serviceUrl + 'ref/subreg?inst=2&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.subreg = res.json();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
      });
  }
  public myCallback1(newVal1) {
    console.log('value is changed to ', newVal1);
    this.officer.NAME = newVal1;
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/auction/report/report.component.ts